import Briefcase from '../../src/legacy/Briefcase';
export default Briefcase;
